// Small numeric helpers shared by the server sim, the client and the codec.

/** Clamps `v` into `[min, max]`. Assumes `min <= max`. A NaN input is returned unchanged. */
export function clamp(v: number, min: number, max: number): number {
  return v < min ? min : v > max ? max : v;
}

/** Clamps `v` into `[0, 1]`. */
export function clamp01(v: number): number {
  return v < 0 ? 0 : v > 1 ? 1 : v;
}

/** Linear interpolation: `a` at `t = 0`, `b` at `t = 1` (not clamped). */
export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

/** The `t` for which `lerp(a, b, t) === v`. Returns 0 when `a === b`. */
export function inverseLerp(a: number, b: number, v: number): number {
  return a === b ? 0 : (v - a) / (b - a);
}

/** True for a number that is neither NaN nor ±Infinity. */
export function isFiniteNumber(v: unknown): v is number {
  return typeof v === 'number' && Number.isFinite(v);
}

/** Rounds `v` to the nearest multiple of `step` (e.g. `roundTo(1.234, 0.01) === 1.23`). */
export function roundTo(v: number, step: number): number {
  return Math.round(v / step) * step;
}
